const createEditandoObject = (defaultValues = false) => {
	return {
		editando: {
			pais: defaultValues,
			estado: defaultValues,
			cidade: defaultValues,
			aeroporto: defaultValues
		}
	}
}

const createCamposLocalidade = (item, tipo, nivel = 1) => {
	if (tipo === 'P') {
		if (nivel >= 1) {
			item.designativo_partida = ''
			item.lat_partida = ''
			item.lng_partida = ''
			item.fuso_partida = ''
			item.decolagem_utc_partida = ''
			item.rotaer_partida = []
		}
		if (nivel >= 2) {
			item.cidade_partida = ''
			item.id_cidade_partida = ''
			item.lista_cidades_partida = []
		}
		if (nivel === 3) {
			item.estado_partida = ''
			item.id_estado_partida = ''
			item.estado_partida = []
		}
	} else {
		// if (tipo == 'D')
		if (nivel >= 1) {
			item.designativo_destino = ''
			item.lat_destino = ''
			item.lng_destino = ''
			item.fuso_destino = ''
			item.rotaer_destino = []
		}
		if (nivel >= 2) {
			item.cidade_destino = ''
			item.id_cidade_destino = ''
			item.lista_cidades_destino = []
		}
		if (nivel === 3) {
			item.estado_destino = ''
			item.id_estado_destino = ''
			item.estado_destino = []
		}
	}
	return item
}


const createTrecho = (editar = false, disableDataPouso = true) => {

	return {
		id: 0,
		numero_voo: 0,
		decolagem_partida: '',
		decolagem_partida_hora: null,
		decolagem_utc_partida: '',
		fuso_partida: '',
		rotaer_local_partida: '',
		id_estado_partida: '',
		nome_estado_partida: '',
		id_cidade_partida: 0,
		nome_cidade_partida: '',
		lat_partida: null,
		lng_partida: null,
		nao_tem_aerodromo: false,
		descricao_partida: '',
		descricao_destino: '',
		erro_descricao_destino: '',
		erro_decolagem: '',
		id_estado_destino: '',
		nome_estado_destino: '',
		id_cidade_destino: 0,
		nome_cidade_destino: '',
		rotaer_local_destino: '',
		lat_destino: null,
		lng_destino: null,
		id_pais_partida: '55',
		pais_partida: {
			codigo:'55',
			descricao:'BRA - Brasil',
			nome:'Brazil',
			sigla:'BRA'
		},
		estado_partida: '',
		cidade_partida: '',
		designativo_partida: '',
		loadCidadePartida: false,
		loadEstadoPartida: false,
		loadAeroportoPartida: false,
		loadCidadeDestino: false,
		loadEstadoDestino: false,
		loadAeroportoDestino: false,
		adicional: false,
		pernoite: false,
		id_pais_destino: '55',
		pais_destino: {
			codigo:'55',
			descricao:'BRA - Brasil',
			nome:'Brazil',
			sigla:'BRA'
		},
		estado_destino: '',
		cidade_destino: '',
		designativo_destino: '',
		tem_pouso_previsto: false,
		pouso_previsto: '',
		pouso_previsto_hora: null,
		pouso_previsto_utc: '',
		fuso_destino: '',
		rotaer_partida: [],
		rotaer_destino: [],
		lista_estados_partida: [],
		lista_estados_destino: [],
		lista_cidades_partida: [],
		lista_cidades_destino: [],
		erro_pouso_previsto: '',
		erro_pais_partida: '',
		erro_estado_partida: '',
		erro_cidade_partida: '',
		erro_pais_destino: '',
		erro_estado_destino: '',
		erro_cidade_destino: '',
		erro_designativo_partida: '',
		erro_designativo_destino: '',
		erro_len_lat_partida: '', 
		erro_len_lng_partida: '',
		erro_len_lat_destino: '',
		erro_len_lng_destino: '',
		erro_pernoite: '',
		destinoEditando: createEditandoObject(editar),
		partidaEditando: createEditandoObject(editar),
		disableDataPouso: disableDataPouso
	}
}


const createProximoTrecho = (trechoAnterior = null) => {
	return Object.assign(createTrecho(), {
		
		id: 0,

		numero_Voo:trechoAnterior.numero_Voo ?? '',

		designativo_partida: trechoAnterior.designativo_destino ?? '',
		designativo_destino: trechoAnterior.designativo_partida ?? '',

		icao_origem: trechoAnterior.icao_destino ?? '',
		icao_destino: trechoAnterior.icao_origem ?? '',

		rotaer_partida: trechoAnterior.rotaer_destino ?? '',
		rotaer_destino: trechoAnterior.rotaer_partida ?? '',

		lat_destino: trechoAnterior.lat_destino ?? '',
		lat_partida: trechoAnterior.lat_partida ?? '',

		lng_destino: trechoAnterior.lng_destino ?? '',
		lng_partida: trechoAnterior.lng_partida ?? '',

		id_estado_partida: trechoAnterior.estado_destino.id ?? '',
		estado_partida: trechoAnterior.estado_destino ?? '',
		nome_estado_destino: trechoAnterior.nome_estado_partida ?? '',

		id_estado_destino: trechoAnterior.estado_partida.id ?? '',
		estado_destino: trechoAnterior.estado_partida,
		nome_estado_partida: trechoAnterior.nome_estado_destino ?? '',

		id_cidade_partida: trechoAnterior.cidade_destino.id ?? '',
		cidade_partida: trechoAnterior.cidade_destino,
		nome_cidade_partida: trechoAnterior.nome_cidade_destino ?? '',

		id_cidade_destino: trechoAnterior.cidade_partida.id ?? '',
		cidade_destino: trechoAnterior.cidade_partida,
		nome_cidade_destino: trechoAnterior.nome_cidade_partida ?? '',

		lista_estados_partida: trechoAnterior.lista_estados_destino ?? '',
		lista_estados_destino: trechoAnterior.lista_estados_partida ?? '',

		lista_cidades_partida: trechoAnterior.lista_cidades_destino ?? '',
		lista_cidades_destino: trechoAnterior.lista_cidades_partida ?? '',

		id_pais_partida: trechoAnterior.pais_destino.codigo ?? '',
		id_pais_destino: trechoAnterior.pais_partida.codigo ?? '',
		pais_partida: trechoAnterior.pais_destino ?? '',
		pais_destino: trechoAnterior.pais_partida ?? '',

		tem_pouso_previsto: trechoAnterior.tem_pouso_previsto ?? '',
		pouso_previsto: '',

		destinoEditando: createEditandoObject(true),
		partidaEditando: createEditandoObject(true),
		disableDataPouso: trechoAnterior.disableDataPouso
	})
}

const limparTrecho = (trecho) => {
	delete trecho.passageiros
	delete trecho.destinoEditando
	delete trecho.lista_estados_partida
	delete trecho.lista_estados_destino
	delete trecho.lista_cidades_partida
	delete trecho.lista_cidades_destino
	delete trecho.erro_pais_partida
	delete trecho.erro_estado_partida
	delete trecho.erro_cidade_partida
	delete trecho.erro_pais_destino
	delete trecho.erro_estado_destino
	delete trecho.erro_cidade_destino
	delete trecho.erro_designativo_partida
	delete trecho.erro_designativo_destino
	delete trecho.erro_pernoite
	delete trecho.rotaer_partida
	delete trecho.rotaer_destino
	delete trecho.erro_pouso_previsto
	delete trecho.loadCidadePartida
	delete trecho.loadEstadoPartida
	delete trecho.loadAeroportoPartida
	delete trecho.loadCidadeDestino
	delete trecho.loadEstadoDestino
	delete trecho.loadAeroportoDestino
	return trecho
}

export default {
	createTrecho,
	createEditandoObject,
	createCamposLocalidade,
	createProximoTrecho,
	limparTrecho
}
